module.exports = __webpack_public_path__ + "img/badge_first.e32b1c27.png";